export const rowCustomHandlerType = {
    HYPPER_LINK: 'hypper-link',
    EDIT: 'edit',
    DELETE: 'delete',
    DETAIL: 'detail',
    CONFIRM: 'confirm',
    SWITCH: 'switch',
    TOGGLE: 'toggle',
    RESTORE: 'restore'
}